import FeedParser from "feedparser";
import { get } from "https";
function retrieve(rssUrl) {
    return new Promise((resolve, reject) => {
        let parsedUrl;
        try {
            parsedUrl = new URL(rssUrl);
        }
        catch (err) {
            return reject(new Error(`Invalid RSS URL: ${rssUrl}`));
        }
        get({
            protocol: parsedUrl.protocol,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            path: parsedUrl.pathname + parsedUrl.search,
            headers: { "User-Agent": "Vortex", Cookie: "rd=true" },
        }, (res) => {
            const { statusCode } = res;
            const contentType = res.headers["content-type"];
            let err;
            if (statusCode !== 200) {
                err = `Request Failed. Status Code: ${statusCode}`;
            }
            const parser = new FeedParser();
            const result = [];
            parser.on("error", (error) => {
                res.destroy();
                reject(error);
            });
            parser.on("readable", () => {
                while (true) {
                    const item = parser.read();
                    if (item === null) {
                        break;
                    }
                    else {
                        result.push(item);
                    }
                }
            });
            parser.on("end", () => {
                resolve(result);
            });
            if (err !== undefined) {
                res.resume();
                return reject(new Error(err));
            }
            res.pipe(parser);
        }).on("error", (err) => {
            return reject(err);
        });
    });
}
export default retrieve;
